import { Box, NoSsr, Stack, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import { CustomStackForLoaction } from "../NavBar.style";
import ThemeSwitches from "./ThemeSwitches";
import AddressReselect from "./address-reselect/AddressReselect";
import CustomLanguage from "./language/CustomLanguage";
import { useSelector } from "react-redux";
import CallToAdmin from "../../CallToAdmin";
import CustomContainer from "../../container";
import LogoSide from "../../logo/LogoSide";
import DrawerMenu from "./drawer-menu/DrawerMenu";

const TopNavBar = ({ configData: propConfigData }) => {
  const { configData: reduxConfigData, countryCode, language } = useSelector(
    (state) => state.configData
  );
  const configData = propConfigData || reduxConfigData;
  const [openDrawer, setOpenDrawer] = useState(false);
  const theme = useTheme();
  
  // Get location for address reselect
  let location = null;
  if (typeof window !== "undefined") {
    location = localStorage.getItem("location");
  }
  
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <NoSsr>
      <Box
        sx={{
          width: "100%",
          background: (theme) => theme.palette.neutral[100],
        }}
      >
        <CustomContainer>
          <Box>
            <Stack
              pt=".4rem"
              pb=".4rem"
              px={isSmall ? "8px" : "0px"}
              width="100%"
              height="30px"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                gap: isSmall ? 1 : 2,
              }}
            >
              {!isSmall && (
                <>
                  <CustomStackForLoaction 
                    direction="row"
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    sx={{
                      flex: "0 1 auto",
                      minWidth: 0,
                      overflow: "hidden",
                      marginRight: "auto"
                    }}
                  >
                    {location && (
                      <AddressReselect
                        setOpenDrawer={setOpenDrawer}
                        location={location}
                      />
                    )}
                  </CustomStackForLoaction>
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    sx={{
                      flexShrink: 0,
                      minWidth: 'fit-content'
                    }}
                  >
                    <ThemeSwitches />
                    <CallToAdmin configData={configData} />
                    <CustomLanguage
                      countryCode={countryCode}
                      language={language}
                    />
                  </Stack>
                </>
              )}
            </Stack>
          </Box>
        </CustomContainer>
      </Box>
    </NoSsr>
  );
};

export default TopNavBar;
